import React from "react";
import { Box, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { ROUTE_MAIN } from "../../constants/routes";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const TermsAndConditions = () => {
  return (
    <Box
      sx={{
        maxWidth: 800,
        margin: "0 auto",
        padding: { xs: 2, sm: 4 },
        minHeight: "100vh",
        backgroundColor: "#fff",
      }}
    >
      <Link
        component={RouterLink}
        to={ROUTE_MAIN}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          color: "#756DE9",
          textDecoration: "none",
          fontSize: "14px",
          fontWeight: 500,
          mb: 3,
          "&:hover": { color: "#5a4dbf" },
        }}
      >
        <ArrowBackIcon fontSize="small" /> Back
      </Link>

      <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 3, color: "#1A1A35" }}>
        Terms and Conditions
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Last updated: {new Date().toLocaleDateString()}
      </Typography>

      <Typography variant="body1" paragraph>
        Please read these Terms and Conditions carefully before using our platform. By accessing or using our services, you agree to be bound by these terms.
      </Typography>

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        1. Acceptance of Terms
      </Typography>
      <Typography variant="body1" paragraph>
        By creating an account or using our services, you accept and agree to these Terms and Conditions and our Privacy Policy. If you do not agree, please do not use our platform.
      </Typography>

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        2. Use of Service
      </Typography>
      <Typography variant="body1" paragraph>
        You agree to use the platform only for lawful purposes and in accordance with these terms. You must not misuse the service, attempt to gain unauthorised access, or use it in any way that could harm the platform or other users.
      </Typography>

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        3. Account Responsibility
      </Typography>
      <Typography variant="body1" paragraph>
        You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must notify us immediately of any unauthorised use.
      </Typography>

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        4. Intellectual Property
      </Typography>
      <Typography variant="body1" paragraph>
        All content, features, and functionality of the platform are owned by us and are protected by intellectual property laws. You may not copy, modify, or distribute our content without prior written consent.
      </Typography>

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        5. Limitation of Liability
      </Typography>
      <Typography variant="body1" paragraph>
        To the fullest extent permitted by law, we shall not be liable for any indirect, incidental, or consequential damages arising from your use of the platform.
      </Typography>

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        6. Contact
      </Typography>
      <Typography variant="body1" paragraph>
        For questions about these Terms and Conditions, please contact us at{" "}
        <Link href="mailto:queries@seevi.in" color="primary">
          queries@seevi.in
        </Link>
        .
      </Typography>
    </Box>
  );
};

export default TermsAndConditions;
